import { Link } from 'react-router-dom';

export default function OwnerTeaserStrip() {
  return (
    <div className="mb-6 rounded-xl overflow-hidden border border-[#E8B84B]/30 bg-gradient-to-r from-[#1A2332] to-[#243044]">
      <div className="flex flex-col sm:flex-row items-stretch">
        {/* Left accent bar */}
        <div className="hidden sm:block w-1 bg-[#E8B84B] flex-shrink-0" />

        {/* Content */}
        <div className="flex-1 px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon */}
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#E8B84B]/15 border border-[#E8B84B]/30 flex-shrink-0">
            <i className="ri-user-smile-line text-[#E8B84B] text-lg" />
          </div>

          {/* Text */}
          <div className="flex-1 min-w-0">
            <p className="text-white/90 text-sm leading-relaxed">
              <span className="text-[#E8B84B] font-bold">Every car here is priced by someone who left the dealership industry on purpose.</span>
              {' '}No rate markup. No mystery fees. No "let me check with my manager." Just a fair price and a straight answer.
            </p>
            <p className="text-white/45 text-xs mt-1 italic">
              — The guy who built this instead of staying quiet about how dealerships actually work
            </p>
          </div>

          {/* CTA */}
          <Link
            to="/about-the-owner"
            className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap cursor-pointer transition-all bg-[#E8B84B]/15 border border-[#E8B84B]/35 text-[#E8B84B] hover:bg-[#E8B84B]/25"
          >
            The Guy Behind the Madness
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>
      </div>
    </div>
  );
}
